import { render, staticRenderFns } from "./Product-user.vue?vue&type=template&id=5389f2c9"
import script from "./Product-user.vue?vue&type=script&lang=js"
export * from "./Product-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports